/**
 * 컴퍼넌트 생성시 필수 상속 class
 * @category common
 * @param  {DataStore} _store={} 데이타 스토어
 * @param  {String} _el='' 컴퍼넌트 선택자
 * @example
 * class MyComp extends AbsComponent{
 * ...
 * }
 * let mycomp = new MyComp( dataStore, '#section .mycomp');
 */
class AbsComponent {
	constructor(_store={}, _el=''){
		/**
		 * @type {DataStore}
		 */
		this.store = _store;

		/**
		 * @type {String}
		 * ex) '#main .container'
		 */
		this.el = _el;
	}

	/**
	 * @param  {Json} _jsonData={} 화면 랜더시 필요한 데이터
	 */
	render(_jsonData = {}){}

	/**
	 * 랜더링 후 설정이나 초기화등
	 */
	setting(){}

	/**
	 * 이벤트 등록
	 */
	addEvents(){}


} // end of class

export default AbsComponent;